module.exports = __webpack_public_path__ + "img/lab-1-text.d5b38abe.svg";